import React, { useState, useEffect } from "react";
import "./Page.scss";
import FirstPage from "../UI/Pages/FirstPage";
import FirstPageIntl from "../UI/Pages/FirstPageIntl";
import SuccessPage from "../UI/Pages/SuccessPage";
import { useStateValue } from "../../store/StateProvider";
import FormPage from "../UI/Pages/FormPage";
import SpinnerOverlay from "../UI/Elements/SpinnerOverlay";
import constants from "../../config/constants";

const Page = () => {
  const [{ country, isFormSubmitted }] = useStateValue();
  const [queryParams, setQueryParams] = useState(null);

  const { PARAM_NAME_FORM_SELECTOR, PARAM_VALUE_INTL_FORM_SELECTOR } = constants;

  useEffect(() => {
    let queryString = window && window.location && window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const params = {};
    urlParams.forEach((value, key) => {
      params[key] = value;
    });

    setQueryParams(params);
  }, []);

  if (!queryParams) {
    return <SpinnerOverlay />;
  }

  if (!country) {
    if (queryParams[PARAM_NAME_FORM_SELECTOR] === PARAM_VALUE_INTL_FORM_SELECTOR) {
      return <FirstPageIntl />;
    }

    return <FirstPage />;
  }

  if (isFormSubmitted) {
    return <SuccessPage />;
  }

  return <FormPage />;
};
export default Page;
